import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Order } from '../models/order.model';
import { DeliveryCompany } from '../models/delivery-company.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private order = new BehaviorSubject(null);
  order$ = this.order.asObservable();

  private openCashRegister = new BehaviorSubject(false);
  openCashRegister$ = this.openCashRegister.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  get getOrderIn() {
    return this.order.value;
  }

  setOrder(order: Order) {
    this.order.next(order);
  }

  get getOpenCashRegister() {
    return this.openCashRegister.value;
  }

  setOpenCashRegister(openCashRegister) {
    this.openCashRegister.next(openCashRegister);
  }

  createOrder(customerId: number, paymentMethodId, locationId, storeId, type, subTotal, total, totalTax, deliveryFee, comeFromSystem, comment, posCashierPeriodId) {
    let order = {
      "customerId": customerId, "products": [], "paymentMethods": [],
      "locationId": locationId, "storeId": storeId, "status": "PAID", "type": type, "deliveryDriverId": null,
      "subtotal": subTotal, "total": total, "comeFromSystem": comeFromSystem, totalTax: totalTax, "deliveryFee": deliveryFee, "note": comment, "posCashierPeriodId": posCashierPeriodId
    };
    this.saveOrder(order);
  }

  editOrder(valueTypeToAdd, valueToAdd) {
    let order = this.order.value;
    if (valueTypeToAdd === 'paymentMethods') {
      order.paymentMethods = valueToAdd;
    } else if (valueTypeToAdd === 'customerChangeData') {
      order.customerChangeData = valueToAdd;
    } else if (valueTypeToAdd == 'total') {
      order.total = valueToAdd;
    } else if (valueTypeToAdd == 'deliveryDriver') {
      order.deliveryDriverId = valueToAdd
    }
    this.saveOrder(order);
  }

  saveCacheOrder() {
    this.saveOrder(JSON.parse(localStorage.getItem("order")));
  }

  saveOrder(order) {
    localStorage.setItem("order", JSON.stringify(order));
    this.order.next(order);
    //this.orderListSource.next(this.orderListSource.getValue().concat([order]));
  }

  addProductOrder(productId: number, note: string, price: number, amount: number, productExtra) {
    let order = this.order.value;
    let product = null;
    if (productExtra.length == 0) {
      if (note != null && note != undefined) {
        product = { "productId": productId, "note": note, "price": price, "amount": amount };
      } else {
        product = { "productId": productId, "price": price, "amount": amount };
      }
    } else {
      if (note != null && note != undefined) {
        product = { "productId": productId, "note": note, "price": price, "amount": amount, "extras": productExtra };
      } else {
        product = { "productId": productId, "price": price, "amount": amount, "extras": productExtra };
      }
    }
    order.products.push(product);
    this.saveOrder(order);
  }

  clearProducts() {
    let order = this.order.value;
    order.products = [];
    this.saveOrder(order);
  }

  sendOrder() {
    let order = this.order.value;
    //let orderFinish = {"customerId": order.customerId,"products": order.products};
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/products`, order, httpOptions);
  }

  calculatePrices(customerId: number, storeId: number, products) {
    let calculate = {
      "customerId": customerId,
      "storeId": storeId,
      "products": products
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/products/calculate-prices`, calculate, httpOptions);
  }

  getAllOrders(storeId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}`, httpOptions);
  }

  getOrdersByDateByStoreId(storeId: number, dateStart, dateEnd) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?initCreatedAt=${dateStart}&endCreatedAt=${dateEnd}`, httpOptions);
  }

  getOrdersWinkFailedByDateByStoreId(storeId: number, dateStart, dateEnd, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/failed-wink/store/${storeId}?initCreatedAt=${dateStart}&endCreatedAt=${dateEnd}&status=${status}`, httpOptions);
  }

  deleteOrdersWinkFailedBywinkOrderId(winkOrderId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.delete<any>(`${environment.url_api}/orders/failed-wink/${winkOrderId}`, httpOptions);
  }

  updateOrdersWinkFailedBywinkOrderId(winkOrderId, body) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/failed-wink/${winkOrderId}`, body, httpOptions);
  }

  getPaidOrders(storeId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?status=PAID`, httpOptions);
  }

  getDeliveredOrders(storeId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/stores/${storeId}?status=DELIVERED`, httpOptions);
  }

  getOrder(orderId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/${orderId}`, httpOptions);
  }

  updateOrderStatus(orderId: number, changes: Partial<Order>) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };

    return this.http.patch(`${environment.url_api}/orders/${orderId}`, changes, httpOptions);
  }

  validateOrderStatus(id: number, statusValidate, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/${id}/validate/${statusValidate}/setStatus`, status, httpOptions);
  }

  updateOrderPaymentMethod(id, paymnetMethods) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/${id}/orderPaymentMethods`, paymnetMethods, httpOptions);
  }

  updateOrderStatusById(id, status) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/orders/${id}`, status, httpOptions);
  }

  getOrdersByFilters(filters) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/totals${filters}`, httpOptions);
  }

  getOrdersPeriodByFilters(filters) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/periods/totals${filters}`, httpOptions);
  }

  getOrdersProductsByFilters(filters) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/order-products/sumary${filters}`, httpOptions);
  }

  getOrdersPeriodCashierPeriodClosedGoing(periodId, storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/periods/${periodId}/stores/${storeId}`, httpOptions);
  }

  getOrdersOldPeriodsFinish(periodId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/orders/olds/periods/${periodId}`, httpOptions);
  }

  validateAndSendOrderToPrint(orderId, storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/${orderId}/parse-and-send-to-fiscal-printer/${storeId}`, httpOptions);
  }

  printReportZ(reportZ, storeId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/orders/report-z-send-to-fiscal-printer/${storeId}`, reportZ, httpOptions);
  }

  /*getAllAvailableDeliveriesCompaniesAndDrivers() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<DeliveryCompany[]>(`${environment.url_api}/delivery-companies/delivery-drivers?ownerId=1&statusDriver=true&statusCompany=true`, httpOptions);
  }*/
}
